import { trace } from 'rytm-helpers'

let updateTimeout
const MOBILE_FALLBACK = 576
const COLUMN_OFFSET = 15


const initPostColumns = () => {
  // trace("init post columns")
  const colMainContent = document.querySelector(".post-col-main > div")
  const colAsideContent = document.querySelector(".post-col-aside > div")
  if (colMainContent && colAsideContent) {
    const recommended = colAsideContent.querySelector(".post-sidebar-recommended")
    if (recommended) {
      // reset
      recommended.style.marginTop = 0
      if (window.innerWidth > MOBILE_FALLBACK) {
        const mainH = colMainContent.offsetHeight
        const asideH = colAsideContent.offsetHeight
        const diff = mainH - asideH
        if (diff > 100) {
          recommended.style.marginTop = (diff + COLUMN_OFFSET) + "px"
        }
      }
      // show recommended
      recommended.classList.add('active')
    }
    
  }
}

export const updatePostColumns = () => {
  clearTimeout(updateTimeout)
  updateTimeout = setTimeout(initPostColumns, 200)
}


// init at start!
initPostColumns()